import MockClassrooms from "../api/mocks/getTeacherClassrooms.json";
import { RenderedClassForTeacher } from "../api/models/teacher";
import { mocksResponse } from "../utils/env";
import { UserManager } from "./UserManager";

export class TeacherManager {
  private static _instance: TeacherManager = new TeacherManager();
  static get instance(): TeacherManager {
    return this._instance;
  }

  private _classrooms: RenderedClassForTeacher[] | undefined;

  async syncClassrooms(dataProvider: () => Promise<RenderedClassForTeacher[]>) {
    if (!UserManager.instance.userId) {
      throw Error("Error syncing teacher classrooms for undefined user.");
    }
    if (mocksResponse()) {
      // return mocked reponse to avoid CORS errors in dev
      this._classrooms = MockClassrooms._items as RenderedClassForTeacher[];
      return;
    }
    this._classrooms = await dataProvider();
  }

  get classes(): RenderedClassForTeacher[] {
    return this._classrooms ?? [];
  }
  set classes(classes: RenderedClassForTeacher[]) {
    this._classrooms = classes;
  }

  get sortedClasses(): RenderedClassForTeacher[] {
    return this.classes.sort((a, b) => b._id.localeCompare(a._id));
  }
}
